import { debounce } from "lodash";

const DEBOUNCE_TIME = 300;
const DEBOUNCE_OPTIONS = { leading: true };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customDebounce = (func: (...args: any) => any) =>
  debounce(func, DEBOUNCE_TIME, DEBOUNCE_OPTIONS);
